import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
// import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import Select from "react-select";

//--------Material React Table------//
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"; //material-react-table
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";

const ItemProfitAbilityByCustomer = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  // const [selectedId, setSelectedId] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  console.log(selectReport, "selectReport");
  // console.log(JSON.parse((sorting)), "sorting")
  // console.log(columnFilters, "columnFilters")

  const handleDropdownChange = (event) => {
    console.log(event, "event");
    setSelectReport(event?.value);
  };

  console.log("11", responseData);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, data) => {
      const reportTotal = Number(data.Amountline);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("startenddate =>", payload, enddate2);
    setStartDate(payload);
    setEndDate(enddate2);
    // console.log("enddate =>", enddate2);
  };

  const totalFooterRow = {
    Customername: "Total",
    Amountline: totalSum,
  };

  const augmentedData = [...responseData, totalFooterRow];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const uniqueStatusValues = useMemo(
    () => [
      ...new Set(responseData?.map((item) => item.Status).filter(Boolean)),
    ],
    [responseData]
  );

  //---------------------Material React Table------------------//
  const columns = useMemo(() => [
    {
      header: "Product/Service",
      accessorKey: "ItemName",
      // enableGrouping: false,
    },
    {
      header: "Customer",
      accessorKey: "CustomerName",
      // enableGrouping: false,
    },
    {
      header: "Transaction id",
      accessorKey: "SaleId",
    },
    {
      header: "Product Variation Name",
      accessorKey: "ItemVariationName",
    },
    {
      header: "Ledger Amount",
      accessorKey: "CostPrice",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(
              row.original.CostPrice ? row.original.CostPrice : 0
            ).toFixed(2)}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => (
        <>
          Oldest by{" "}
          {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
          <Box
            sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
          >
            {" " +
              cell.getValue()?.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                // minimumFractionDigits: 0,
                // maximumFractionDigits: 0,
              })}
          </Box>
        </>
      ),
    },
    {
      header: "Invoice Date",
      accessorFn: (originalRow) => moment(originalRow.InvoiceDate), 
      filterVariant: "date",
      Cell: ({ row }) =>
        moment(row.original.InvoiceDate).format("MM/DD/YYYY") ===
      "Invalid date"
      ? ""
      : moment(row.original.InvoiceDate).format("MM/DD/YYYY"),
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      accessorFn: (originalRow) => moment(originalRow.DueDate), 
      filterVariant: "date",
      Cell: ({ row }) =>
        moment(row.original.DueDate).format("MM/DD/YYYY") ===
        "Invalid date"
          ? ""
          : moment(row.original.DueDate).format("MM/DD/YYYY"),
    },
    {
      header: "Invoice Num",
      accessorKey: "InvoiceNo",
    },
    {
      header: "Amount",
      accessorKey: "SalePrice",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(
              row.original.SalePrice ? row.original.SalePrice : 0
            ).toFixed(2)}
          </div>
        );
      },
    },
    {
      header: "Total Quantity",
      accessorKey: "TotalQuantity",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(
              row.original.TotalQuantity ? row.original.TotalQuantity : 0
            ).toFixed(2)}
          </div>
        );
      },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(row.original.Profit ? row.original.Profit : 0).toFixed(2)}
          </div>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "Status",
      filterSelectOptions: uniqueStatusValues, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
    },
    {
      header: "Sale Time",
      accessorFn: (originalRow) => moment(originalRow.Saletime),
      filterVariant: "date",
      Cell: ({ row }) =>
        moment(row.original.Saletime).format("MM/DD/YYYY") === "Invalid date"
          ? ""
          : moment(row.original.Saletime).format("MM/DD/YYYY"),
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      Cell: ({ row }) => {
        const OpenBalance = parseFloat(row?.original?.OpenBalance);

        if (isNaN(OpenBalance) || OpenBalance === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {`${OpenBalance.toFixed(2)}`}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => (
        <>
          Oldest by{" "}
          {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
          <Box
            sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
          >
            {" " + Number(cell.getValue())}
          </Box>
        </>
      ),
    },
    {
      header: "Account Name",
      accessorKey: "AccountName",
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
    },
  ]);

  useEffect(() => {
    // const fetchData = async () => {

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/itemprofitabilitybycustomer?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          const data = res.data.ResponseData;

          const FilterData = data?.map((el) => ({
            ...el,
            CostPrice: Number(el?.CostPrice),
            OpenBalance: Number(el?.OpenBalance),
            InvoiceNo: el?.InvoiceNo ?  Number(el?.InvoiceNo) : "",
            InvoiceDate: moment(el?.InvoiceDate).format("MM/DD/YYYY"),
            DueDate: moment(el?.DueDate).format("MM/DD/YYYY"),
          }));

          setResponseData(FilterData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    // }
    // fetchData();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
  ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Sales By Customer Detail</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Item Profitability By Customer
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    //   defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find(
                      (el) => el?.value === selectReport
                    )}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center " id="header">
                  <h6 class="p">SonarPos</h6>
                  <p className="fw-bold p-regular">
                    Item Profitability By Customer
                  </p>
                  <div className="row mb-0">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />
              <div>
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Item Profit Ability By Customer"
                  columns={columns}
                  data={responseData}
                  startdate={startdate}
                  enddate={enddate}
                  columnGrouping={["ItemName", "CustomerName", "SaleId"]}
                  columnsVisibility={{}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemProfitAbilityByCustomer;
